import React from 'react';
import { UI } from 'src/apps/invest/signup/views/components/UI';
import { useSignUpModel } from '../../models/SignUpModel';
import { PhoneNumberForm } from '../components/PhoneNumberForm';
import { Transition } from '../components/Transition';

export const SignUpPhoneNumberPage: React.FC = () => {
  const { phone } = useSignUpModel();

  return (
    <UI
      prevPage={() => useSignUpModel.setState({ page: 'NAME' })}
      nextPage={phone ? () => useSignUpModel.setState({ page: 'CODE' }) : undefined}>
      <Transition>
        <PhoneNumberForm />
      </Transition>
    </UI>
  );
};
